import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { IoCallOutline } from "react-icons/io5";

import SectionBadge from "@/components/shared/Title";
import ContactInfo from "./ContactInfo";
import ContactForm from "./ContactForm";

import MotionDiv from "@/components/animations/MotionDiv";
import { fadeUp, fadeIn, scaleUp } from "@/animations/variants";

export default function ContactSection() {
  const { t, i18n } = useTranslation();

  const isAR = i18n.language?.toLowerCase().startsWith("ar");
  const data = t("contact-us", { returnObjects: true }) || {};

  return (
    <section
      id="contact"
      dir={isAR ? "rtl" : "ltr"}
      className="px-4 py-16 sm:px-8 md:px-12 lg:px-16"
    >
      {/* Header */}
      <MotionDiv variants={fadeUp} className="mx-auto mb-12 max-w-6xl text-center">

        <SectionBadge text={t("contact")} icon={<IoCallOutline />} />

        <MotionDiv variants={fadeUp}>
          <h2 className="text-primary mt-8 text-3xl font-extrabold">
            <Trans
              i18nKey="contact-us.title"
              components={{
                highlight: <span className="text-primary" />,
              }}
            />
          </h2>
        </MotionDiv>

        <MotionDiv variants={fadeUp}>
          <p className="mt-3 text-xl font-semibold text-gray-500">
            {data?.subtitle}
          </p>
        </MotionDiv>

      </MotionDiv>

      {/* Content */}
      <MotionDiv
        variants={scaleUp}
        className="mx-auto grid max-w-6xl overflow-hidden rounded-2xl shadow-xl md:grid-cols-5"
      >
        <ContactInfo data={data} isAR={isAR} />
        <ContactForm isAR={isAR} />
      </MotionDiv>

    </section>
  );
}